//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import providerDefaultSetting from '../components/providerDefaultSetting.vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
export default {
  components: {
    providerDefaultSetting,
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 加载状态
      loading: false,
      sandboxTypes: [
        { label: ' 待执行', value: ' 0' },
        { label: '执行中', value: '2' },
        { label: '已完成', value: '3' },
        { label: '失败', value: '4' },
        { label: '部分失败', value: '5' },
      ],
      sandboxStatus: [
        { label: ' 待执行', value: '0' },
        { label: '执行中', value: '2' },
        { label: '已完成', value: '3' },
        { label: '失败', value: '4' },
        { label: '部分失败', value: '5' },
      ],
      // 搜索表单
      sandBoxSearch: {
        sandbox_name: '',
        sandbox_type: '',
        task_status: '',
        create_time: '',
        update_time: '',
        update_by: '',
      },
      // 新建窗口展示
      settingVisible: false,
      // 模型文件部署
      deployVisible: false,
      detailVisible: false,
      cloneVisible: false,
      operateType: '',
      rowMessage: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'aiAgentAiModelManagement_agent_systemModelSetting',
        'aiAgentAiModelManagement_agent_delete',
        'aiAgentAiModelManagement_agent_add',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.getList();
    // 'pppp'
    // console.log("%c Line:313 🥥 'pppp'", 'color:#2eafb0', 'pppp');
  },
  methods: {
    toModelList(rowMessage) {
      // rowMessage.provider_name
      console.log(
        '%c Line:230 🍐 rowMessage.provider_name',
        'color:#ffdd4d',
        rowMessage.provider_name,
      );
      this.$router.push({
        name: 'ai-model-sub-list',
        query: {
          provider_name: rowMessage.provider_name,
        },
      });
    },

    toAdd() {
      this.operateType = 'add';
      this.settingVisible = true;
    },

    addProvider(row) {
      // row
      console.log('%c Line:268 🥚 row', 'color:#f5ce50', row);
      const params = {
        provider_name: row.provider_name,
        credentials: '{}',
      };
      this.$request({
        url: this.$api.aiAddProvider,
        data: params,
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.refresh();
      });
    },

    toDelete(row) {
      console.log('%c Line:268 🥚 row', 'color:#f5ce50', row);
      const params = {
        provider_name: row.provider_name,
      };
      this.$request({
        url: this.$api.aiDeleteProvider,
        data: params,
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.refresh();
      });
    },

    refresh() {
      this.resetPage();
      this.getList();
    },

    // 获取列表数据
    getList() {
      this.loading = true;
      console.log('%c Line:263 🍺 this.sandBoxSearch)', 'color:#465975', this.sandBoxSearch);
      const params = {};
      if (this.sandBoxSearch.sandbox_name) {
        params.sandbox_name = this.sandBoxSearch.sandbox_name;
      }
      if (this.sandBoxSearch.sandbox_type) {
        params.sandbox_type = this.sandBoxSearch.sandbox_type;
      }
      if (this.sandBoxSearch.task_status) {
        params.task_status = Number(this.sandBoxSearch.task_status);
      }
      if (this.sandBoxSearch.update_by) {
        params.update_by = this.sandBoxSearch.update_by;
      }
      return this.$request({
        url: this.$api.aiListProviders,
        data: {
          // offset: (this.pageIndex - 1) * this.pageSize,
          // limit: this.pageSize,
          // ...params,
        },
      })
        .then((res) => {
          // res
          console.log('%c Line:261 🍊 res', 'color:#7f2b82', res);
          const computedList = res.providers
            .sort((a, b) => {
              return (b.added === true) - (a.added === true);
            })
            .map((item) => ({
              ...item,
              added: item.added ? '是' : '否',
              enabled: item.enabled ? '是' : '否',
            }));
          this.tableData = computedList;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),

    handleReset() {
      this.resetPage();
      this.refresh();
    },

    resetPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
  },
};
